import { APPOINTMENT_CONFIRMATION_ROUTE } from 'utils/constants/Helpers'

export const SENTRY_ERROR_CAPTURE_STRING = ' - For Sentry'

export const TIMESLOT_SELECTION_FAILED = 'Unable to select esthetician timeslot'
export const USER_LOGIN_FAILED = 'Login failed'
export const USER_EMAIL_UPDATE_FAILED = 'Email update failed'
export const USER_EMAIL_VERIFY_FAILED = 'Email verification failed'
export const CARD_REMOVE_FAILED = 'Failed to remove card'
export const FETCH_USER_INFO_FAILED = 'Unable to fetch user information'
export const REMOVE_ENHANCEMENT_FAILED = 'Failed to remove enhancement'
export const MEMBERSHIP_CHECKOUT_FAILED = 'Membership checkout failed'
export const FAILED_FETCH_LOCATION_DETAILS = 'Unable to fetch location details'
export const FAILED_MOVE_FROM_LOCATION_SCREEN =
  'Failed to proceed from location selection'
export const FAILED_MOVE_APPT_CONFIRM_ROUTE = `Failed to navigate to ${APPOINTMENT_CONFIRMATION_ROUTE}`
export const FAILED_CHECK_MEMBER = 'Membership check failed'
export const FAILED_CREATE_LASER_FACIAL =
  'Failed to create laser facial appointment'
